import React, { useState } from "react";
import { Box, ToggleButtonGroup } from "@mui/material";
import { ToggleButtonPartialShipmentStyled } from "./PartialShipment.style";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useFormClasses } from "./CreateOfferOrderForm.style";


type ShipToAddressProps = {
    onChange: any;
    defaultValue:boolean;
};

const PartialShipment = (props: ShipToAddressProps) => {
    const [selected, setSelected] = useState(props.defaultValue);

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newSelected: boolean
    ) => {
          if (newSelected !== null) {
              setSelected(newSelected);
              props.onChange(event, newSelected);
          }
    };
    



    const { t } = useTranslation();
    const classesForm=useFormClasses();
    return (
        <Box component="div">
            <Box sx={classesForm.title}> {t("orderoffer.partial_ship")} </Box>
            <ToggleButtonGroup
                value={selected}
                exclusive
                onChange={handleChange}
                aria-label="yes no toggle"
            >
                <ToggleButtonPartialShipmentStyled value={true}>
                    YES
                </ToggleButtonPartialShipmentStyled>
                <ToggleButtonPartialShipmentStyled value={false}>
                    NO
                </ToggleButtonPartialShipmentStyled>
            </ToggleButtonGroup>
        </Box>
    );
};

export default PartialShipment;
